import { useEffect, useRef } from "react";
import { toast } from "sonner";

// Detects a newly deployed build (changed hashed JS bundles in index.html) and
// prompts the user to refresh. index.html is served no-cache, so this reliably
// catches deploys even when the SPA tab stayed open (e.g. iPad Safari).
const BUNDLE_RE = /\/static\/js\/[^"']+\.js/g;

async function fetchBundleHash() {
  try {
    const res = await fetch(`/index.html?_=${Date.now()}`, { cache: "no-store" });
    if (!res.ok) return null;
    const html = await res.text();
    const matches = html.match(BUNDLE_RE);
    return matches ? matches.join("|") : null;
  } catch {
    return null;
  }
}

export default function VersionWatcher() {
  const initial = useRef(null);
  const notified = useRef(false);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      const hash = await fetchBundleHash();
      if (cancelled || !hash) return;
      if (initial.current == null) { initial.current = hash; return; }
      if (hash !== initial.current && !notified.current) {
        notified.current = true;
        toast("A new version of Alteza is available.", {
          description: "Refresh to get the latest features.",
          duration: Infinity,
          action: { label: "Refresh", onClick: () => window.location.reload() },
        });
      }
    };

    check();
    const id = setInterval(check, 120000); // every 2 min
    const onFocus = () => check();
    window.addEventListener("focus", onFocus);
    return () => { cancelled = true; clearInterval(id); window.removeEventListener("focus", onFocus); };
  }, []);

  return null;
}
